/**
 * @generated SignedSource<<b85888b2e0c1c7332171160afbdd0227>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SupportChatTouchpoint = "Buyer_Messaging" | "Guest_Buyer_Messaging" | "Seller_Messaging" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useSupportChat_supportChat$data = {
  readonly isLiveAgentAvailable: boolean | null;
  readonly touchpoint: SupportChatTouchpoint | null;
  readonly " $fragmentType": "useSupportChat_supportChat";
};
export type useSupportChat_supportChat$key = {
  readonly " $data"?: useSupportChat_supportChat$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_supportChat">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSupportChat_supportChat",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "touchpoint",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLiveAgentAvailable",
      "storageKey": null
    }
  ],
  "type": "SupportChatQuery",
  "abstractKey": null
};

(node as any).hash = "c17dd9219e754b4e9101c6c6be81e2ed";

export default node;
